import React, { useEffect, useState, useCallback } from 'react';
import RecibosRefactored from './RecibosRefactored';
import CustomNavbar from '../components/Navbar';
import EmployeeCard from '../components/Card';
import DocumentUpload from '../components/DocumentUpload';
import BubbleButton from '../components/BubbleButton'
import { Container, Row, Col, Alert, Tabs, Tab, Card, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../styles/recibos.css';

// En desarrollo usar backend local, en producción usar proxy
const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:4004' 
  : '';

const RecibosView = () => {
  const [userData, setUserData] = useState(null);
  const [token, setToken] = useState(null);
  const [recibos, setRecibos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('recibos');
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');

    if (!storedUser || !storedToken) {
      navigate('/');
      return;
    }

    setUserData(JSON.parse(storedUser));
    setToken(storedToken);
    
    // Obtener CUIL del empleado si no está en los datos guardados
    const fetchCUIL = async () => {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (!parsedUser.CUIL && parsedUser.Legajo) {
          const response = await fetch(`${API_URL}/api/empleados/${parsedUser.Legajo}`, {
            headers: {
              'Authorization': `Bearer ${storedToken}`,
              'Content-Type': 'application/json'
            }
          });
          
          if (response.ok) {
            const empleado = await response.json();
            const updatedUser = { ...parsedUser, CUIL: empleado.CUIL };
            setUserData(updatedUser);
            localStorage.setItem('user', JSON.stringify(updatedUser));
          }
        }
      } catch (error) {
        console.error('Error obteniendo CUIL:', error);
      }
    };
    
    fetchCUIL();
  }, [navigate]);

  const fetchRecibos = useCallback(async () => {
    if (!userData || !token) return;

    try {
      setLoading(true);
      setError(null);

      // Usar nuevo endpoint de recibos JWT
      const response = await fetch(
        `${API_URL}/api/recibos/mis-recibos`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 401) {
        // Token inválido o expirado
        setError('Sesión expirada. Por favor, inicie sesión nuevamente.');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setTimeout(() => navigate('/'), 2000);
        return;
      }

      if (!response.ok) {
        throw new Error(`Error al obtener los recibos (${response.status})`);
      }

      const data = await response.json();
      // El backend devuelve {success: true, data: [...]}
      setRecibos(data.data || data);
    } catch (err) {
      console.error('Error fetching recibos:', err);
      setError(err.message || 'Error al cargar los recibos');
    } finally {
      setLoading(false);
    }
  }, [userData, token, navigate]);

  useEffect(() => {
    if (userData && token) {
      fetchRecibos();
    }
  }, [userData, token, fetchRecibos]);

  if (loading) {
    return (
        <div className="init-container">
        <CustomNavbar />
        <Container className="py-4 text-center">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Cargando recibos...</p>
        </Container>
        </div>
    );
  }

  const handleDocumentsComplete = (result) => {
    // Documentos completados - manejar resultado si es necesario
  };

  return (
    
    <div className="init-container">
      <CustomNavbar userData={userData} />
      <Container className="main-content py-4">
        {/* <Row className="justify-content-center">
          <Col xs={12}>
            {error && <Alert variant="danger">{error}</Alert>}
            {!error && (
              <Recibos
                recibos={recibos}
                userLegajo={userData?.Legajo}
                userName={userData?.Nombre}
                refetchRecibos={fetchRecibos}
              />
            )}
          </Col>
        </Row> */}

        {!error && (
          <>
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-3 custom-tabs"
            >
              <Tab eventKey="recibos" title="Recibos">
                <Row className="justify-content-center">
                  <Col lg={4} className="mb-4">
                    {userData && <EmployeeCard userData={userData} />}
                  </Col>

                  <Col lg={8}>
                    <RecibosRefactored
                      recibos={recibos}
                      userLegajo={userData?.Legajo}
                      userName={userData?.Nombre}
                      refetchRecibos={fetchRecibos}
                    />
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="documentos" title="Subir Documentos">
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <DocumentUpload 
                      empleado={{ 
                        legajo: userData?.Legajo, 
                        cuil: userData?.CUIL 
                      }}
                      onDocumentsComplete={handleDocumentsComplete}
                    />
                  </Col>
                </Row>
              </Tab>
            </Tabs>
          </>
        )}
      </Container>
      <BubbleButton></BubbleButton>

    </div>
    
  );
};

export default RecibosView;
